export default "__VITE_ASSET__BY5BP$2R__"